<div class="dialog-container">
    <div class="dialog-header">
        <h2>{{ hotel?.name }}</h2>
        <div class="mat-action">                
            <div class="full-screen">
                <!-- {{ isFullscreen ? 'Exit Fullscreen' : 'View Fullscreen' }} -->
                <a matTooltip="{{ isFullscreen ? 'Exit Fullscreen' : 'View Fullscreen' }}" (click)="toggleFullscreen()">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 12L17 7M17 7H13.25M17 7V10.75"
                      stroke="black"
                      stroke-width="1.6875"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 12L7 17M7 17H10.75M7 17V13.25"
                      stroke="black"
                      stroke-width="1.6875"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8"
                      stroke="black"
                      stroke-width="1.6875"
                      stroke-linecap="round"
                    />
                  </svg>
                </a>
              </div>
              <mat-icon matTooltip="Close dialog" (click)="closeDialog()">close</mat-icon>
        </div>
    </div>
    <div class="dialog-content">
        <iframe 
            [src]="getEmbeddedMapUrl()" 
            width="100%" 
            height="100%" 
            frameborder="0" 
            style="border:0;" 
            allowfullscreen="true" 
            loading="lazy">
        </iframe>
    </div>
</div>
